import { ImageIcon } from 'lucide-react';
import type { SkuPhoto } from '../../types';

function getThumbnailUrl(photo: SkuPhoto, orgId: string, skuId: string): string | null {
  if (photo.mongoFileId) {
    return `/api/v4/legacy/v2/files/${orgId}/${photo.mongoFileId}-100x100.jpg`;
  }
  if (photo.id && skuId) {
    return `/api/v4/wms/skus/${skuId}/photos/${photo.id}/download`;
  }
  return null;
}

function getFullUrl(photo: SkuPhoto, skuId: string): string | null {
  if (photo.mongoFileId) {
    return `/api/v4/legacy/v2/files/${photo.mongoFileId}`;
  }
  if (photo.id && skuId) {
    return `/api/v4/wms/skus/${skuId}/photos/${photo.id}/download`;
  }
  return null;
}

interface PhotoCellProps {
  photos: SkuPhoto[];
  orgId: string;
  skuId: string;
}

export function PhotoCell({ photos, orgId, skuId }: PhotoCellProps) {
  if (!photos || photos.length === 0) {
    return <span className="text-muted-foreground">—</span>;
  }

  return (
    <div className="flex items-center gap-0.5">
      {photos.slice(0, 3).map((photo) => {
        const src = getThumbnailUrl(photo, orgId, skuId);
        const fullSrc = getFullUrl(photo, skuId);
        if (!src) {
          return (
            <div
              key={photo.id}
              className="h-10 w-10 rounded border bg-muted flex items-center justify-center"
            >
              <ImageIcon className="h-4 w-4 text-muted-foreground" />
            </div>
          );
        }
        return (
          <a
            key={photo.id}
            href={fullSrc || '#'}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={src}
              alt=""
              className="h-10 w-10 rounded object-cover border hover:ring-2 hover:ring-primary transition-shadow"
              onError={(e) => {
                const img = e.target as HTMLImageElement;
                img.style.display = 'none';
              }}
            />
          </a>
        );
      })}
      {photos.length > 3 && (
        <span className="text-xs text-muted-foreground ml-1">
          +{photos.length - 3}
        </span>
      )}
    </div>
  );
}
